import * as Store from '@apply/store';
import { FileOrFormQuestion, PageQuestionFileProps } from '@apply/ui';
import { connect } from 'react-redux';

const CapitalExpendituresFile: React.FC<PageQuestionFileProps> = ({
    onQuestionValidate,
    submitted,
    handleFileSelected,
    property,
    onChange,
    required,
}) => {
    return (
        <div className='form-group'>
            <div className='row'>
                <FileOrFormQuestion
                    submitted={submitted}
                    selector='capitalExpenditures'
                    styleName='ungrouped'
                    onQuestionValidate={onQuestionValidate}
                    value={property.rental?.capitalExpenditures}
                    onChangeQualifier={property.guid}
                    onChange={onChange}
                    fileType='capital expenditures'
                    onFileSelected={handleFileSelected}
                    required={required}
                >
                    Capiture Expenditures
                </FileOrFormQuestion>
            </div>
        </div>
    );
};

export const mapStateToProps = (state: Store.ApplyRootStateType) => {
    return {
        property: state.properties.items.find((itm) => itm.guid === state.properties.currentPropertyId),
        loanType: state.borrower.loanType,
    };
};

export const mapDispatchToProps = (dispatch: Store.ApplyDispatchType) => {
    const props: {
        onChange: (guid: string, value: Store.PropertiesStore.Types.Attachment) => void;
        dispatch: Store.ApplyDispatchType;
    } = {
        onChange: (guid: string, value: Store.PropertiesStore.Types.Attachment) =>
            dispatch(Store.PropertiesStore.Actions.updateCapitalExpenditures(guid, value)),
        dispatch,
    };
    return props;
};

export default connect(mapStateToProps, mapDispatchToProps)(CapitalExpendituresFile);
